import React from "react"
import owl from "../assets/images/tv-owl.jpg"
import email from "../assets/common/email.svg"
import clock from "../assets/common/clock.svg"
import refresh from "../assets/common/refresh.svg"
const ErrorFallback = ({ error, resetErrorBoundary }) => {

    const queryParams = new URLSearchParams(location.search);
    const clientMessage = queryParams.get('msg')
    let splitMsg = clientMessage.split(":")
    return (
        <>
            {clientMessage == null && (
                <div role="alert" style={{ padding: "20px", textAlign: "center" }}>
                    <h1>Something went wrong.</h1>
                    <p>{error?.message}</p>
                    <button onClick={resetErrorBoundary}>Try Again</button>
                </div>
            )}
            {clientMessage !== null && (
                <div className="error-container">
                    <div className="error-image-container">
                        <img src={owl} alt="TV-Owl Screen" width={200} height={200} />
                    </div>

                    <h1>Well, this is embarrassing...</h1>
                    <p className="mb-2"><code className="code-first">
                        {splitMsg[0]}: 
                    </code>
                        <code className="code-last">
                         "{splitMsg[1]}"
                        </code>
                    </p>
                    <p className="mb-5">
                        Sorry, this is not working properly. We now know about this mistake and are working to fix it.
                    </p>
                    <p className="mb-3">In the meantime, here is what you can do:</p>

                    <ul>
                        <li><img src={refresh} alt="Refresh" /><strong>Refresh the page</strong> (sometimes this helps).</li>
                        <li><img src={clock} alt="Retry" /><strong>Try again in 30 minutes.</strong></li>
                        <li>
                            <img src={email} alt="Email" />
                            <strong>Email us at</strong>
                            <a href="mailto:braunics.im@pg.com">braunics.im@pg.com</a> and tell us what happened
                        </li>
                    </ul>
                </div>

            )}
        </>
    )
}

export default ErrorFallback